import React from 'react';
import SafeCountUp from "../../Components/Common/SafeCountUp";
import { Link } from 'react-router-dom';
import { Card, CardBody, Col } from 'reactstrap';
//import { ecomWidgets } from "../../common/data";

const Widgets = (data) => {
    debugger
    const data1=data.data.total_sell_amount
    return (
        <React.Fragment> 
        <Col xl={4} md={6} >
            <Card className="card-animate">
                <CardBody>
                    <div className="d-flex align-items-center">
                        <div className="flex-grow-1 overflow-hidden">
                            <p className="text-uppercase fw-medium text-muted text-truncate mb-0">Total Sales</p>
                        </div>
                        <div className="flex-shrink-0">
                            <h5 className="fs-14 mb-0 text-success" >
                                {/* <i className="fs-13 align-middle ri-arrow-right-up-line"></i> +16.24 % */}
                            </h5>
                        </div>
                    </div>
                    <div className="d-flex align-items-end justify-content-between mt-4">
                        <div>
                            <h4 className="fs-22 fw-semibold ff-secondary mb-4"><span className="counter-value" data-target="559.25">
                                <SafeCountUp
                                    start={0}
                                    prefix="$"
                                    suffix=""
                                    separator=","
                                    end={data.data.total_sell_amount || 0}
                                    decimals={2}
                                    duration={4}
                                    delay={150}
                                />
                            </span></h4>
                            {/* <Link to="#" className="text-decoration-underline link-secondary">View net earnings</Link> */}
                        </div>
                        <div className="avatar-sm flex-shrink-0">
                            <span className={"avatar-title rounded fs-3 bg-primary-subtle"}>
                                <i className="text-primary bx bx-dollar-circle"></i>
                            </span>
                        </div>
                    </div>
                </CardBody>
            </Card>
        </Col> 
                <Col xl={4} md={6}  >
                    <Card className="card-animate">
                        <CardBody>
                            <div className="d-flex align-items-center">
                                <div className="flex-grow-1 overflow-hidden">
                                    <p className="text-uppercase fw-medium text-muted text-truncate mb-0">Orders</p>
                                </div>
                                <div className="flex-shrink-0">
                                    <h5 className="fs-14 mb-0 text-danger">
                                         {/* <i className="fs-13 align-middle ri-arrow-right-down-line" ></i>   -3.57 % */}
                                    </h5>
                                </div>
                            </div>
                            <div className="d-flex align-items-end justify-content-between mt-4">
                                <div>
                                    <h4 className="fs-22 fw-semibold ff-secondary mb-4"><span className="counter-value" data-target="559.25">
                                        <SafeCountUp
                                            start={0}
                                            prefix=""
                                            suffix=""
                                            separator=","
                                            end={data.data.total_orders || 0}
                                            decimal={0}
                                            duration={4}
                                            delay={200}
                                        />
                                    </span></h4>
                                    <Link to="/order-list" className="text-decoration-underline link-secondary"> View all orders</Link>
                                </div>
                                <div className="avatar-sm flex-shrink-0">
                                    <span className={"avatar-title rounded fs-3 bg-primary-subtle"}>
                                        <i className={`text-primary bx bx-shopping-bag`}></i>
                                    </span>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </Col> 
                <Col xl={4} md={6} >
                    <Card className="card-animate">
                        <CardBody>
                            <div className="d-flex align-items-center">
                                <div className="flex-grow-1 overflow-hidden">
                                    <p className="text-uppercase fw-medium text-muted text-truncate mb-0">Customers</p>
                                </div>
                                <div className="flex-shrink-0">
                                    <h5 className={"fs-14 mb-0 text-success"  }>
                                          {/* <i className={"fs-13 align-middle ri-arrow-right-up-line" }></i>  +29.08 % */}
                                    </h5>
                                </div>
                            </div>
                            <div className="d-flex align-items-end justify-content-between mt-4">
                                <div>
                                    <h4 className="fs-22 fw-semibold ff-secondary mb-4"><span className="counter-value" data-target="559.25">
                                        <SafeCountUp
                                            start={0}
                                            prefix=""
                                            suffix=""
                                            separator=","
                                            end={data.data.total_customers || 0}
                                            decimal={0}
                                            duration={4}
                                            delay={250}
                                        />
                                    </span></h4>
                                    {/* <Link to="#" className="text-decoration-underline link-secondary">See details</Link> */}
                                </div>
                                <div className="avatar-sm flex-shrink-0">
                                    <span className={"avatar-title rounded fs-3 bg-primary-subtle"}>
                                        <i className={`text-primary bx bx-user-circle`}></i>
                                    </span>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </Col> 
        </React.Fragment>
    );
};

export default Widgets;